// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2F6fz","content":"styles_content__3nQl4","selectAll":"styles_selectAll__1NXhS"};